/**
 * Product page enhancement functions
 */

// Initialize product page functionality
document.addEventListener('DOMContentLoaded', function() {
  initProductImageZoom();
  initColorSwatches();
  initVariantOptionButtonLabels();
});

/**
 * Initialize image zoom functionality
 */
function initProductImageZoom() {
  const zoomableImages = document.querySelectorAll('.product-main-image--zoomable');
  
  if (!zoomableImages.length) return;
  
  // Create zoom container if it doesn't exist
  let zoomContainer = document.querySelector('.product-image-zoom');
  if (!zoomContainer) {
    zoomContainer = document.createElement('div');
    zoomContainer.className = 'product-image-zoom';
    
    const zoomImage = document.createElement('img');
    zoomImage.className = 'zoom-image';
    
    const closeButton = document.createElement('button');
    closeButton.className = 'zoom-close';
    closeButton.innerHTML = '&times;';
    closeButton.setAttribute('aria-label', 'Close zoom');
    
    zoomContainer.appendChild(zoomImage);
    zoomContainer.appendChild(closeButton);
    document.body.appendChild(zoomContainer);
    
    // Close zoom on button click
    closeButton.addEventListener('click', function() {
      zoomContainer.classList.remove('active');
    });
    
    // Close zoom on background click
    zoomContainer.addEventListener('click', function(e) {
      if (e.target === zoomContainer) {
        zoomContainer.classList.remove('active');
      }
    });
    
    // Close zoom on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && zoomContainer.classList.contains('active')) {
        zoomContainer.classList.remove('active');
      }
    });
  }
  
  // Setup zoom functionality for each zoomable image
  zoomableImages.forEach(container => {
    const image = container.querySelector('img');
    if (!image) return;
    
    image.addEventListener('click', function() {
      const fullSizeUrl = this.src.replace('600x600', '1200x1200');
      const zoomImage = document.querySelector('.zoom-image');
      
      if (zoomImage) {
        zoomImage.src = fullSizeUrl;
        zoomImage.alt = this.alt;
        zoomContainer.classList.add('active');
      }
    });
  });
}

/**
 * Initialize color swatch functionality
 */
function initColorSwatches() {
  const colorOptions = document.querySelectorAll('.option-name');
  
  colorOptions.forEach(optionName => {
    // Check if option is a color option (case insensitive)
    if (optionName.textContent.toLowerCase().includes('color')) {
      const optionContainer = optionName.closest('.product-option');
      const optionButtons = optionContainer.querySelectorAll('.option-button');
      
      optionButtons.forEach(button => {
        // Add color swatch class
        button.classList.add('color-swatch');
        
        // Get color value from label
        const label = button.querySelector('.option-label');
        const colorName = label.textContent.trim();
        
        // Create tooltip
        const tooltip = document.createElement('span');
        tooltip.className = 'tooltip';
        tooltip.textContent = colorName;
        button.appendChild(tooltip);
        
        // Create inner color swatch
        const colorSwatch = document.createElement('span');
        colorSwatch.className = 'color-swatch-inner';
        
        // Try to match color name to CSS color
        let colorValue = getColorValue(colorName);
        colorSwatch.style.backgroundColor = colorValue;
        
        // Replace text with color swatch
        label.textContent = '';
        label.appendChild(colorSwatch);
      });
    }
  });
}

/**
 * Try to convert color name to CSS color value
 */
function getColorValue(colorName) {
  // Convert to lowercase for matching
  const color = colorName.toLowerCase();
  
  // Common color name mappings
  const colorMap = {
    'black': '#000000',
    'white': '#FFFFFF',
    'red': '#FF0000',
    'green': '#008000',
    'blue': '#0000FF',
    'yellow': '#FFFF00',
    'purple': '#800080',
    'pink': '#FFC0CB',
    'orange': '#FFA500',
    'brown': '#A52A2A',
    'grey': '#808080',
    'gray': '#808080',
    'silver': '#C0C0C0',
    'gold': '#FFD700',
    'navy': '#000080',
    'teal': '#008080',
    'olive': '#808000',
    'maroon': '#800000'
  };
  
  // Check if color is in our map
  if (colorMap[color]) {
    return colorMap[color];
  }
  
  // Try direct interpretation
  // For more complex names like "light blue" or "dark green"
  if (color.includes('light') && color.includes('blue')) return '#ADD8E6';
  if (color.includes('dark') && color.includes('blue')) return '#00008B';
  if (color.includes('light') && color.includes('green')) return '#90EE90';
  if (color.includes('dark') && color.includes('green')) return '#006400';
  
  // Return the name itself, browsers can interpret many color names
  return color;
}

/**
 * Format option button labels for better display
 */
function initVariantOptionButtonLabels() {
  const optionButtons = document.querySelectorAll('.option-button:not(.color-swatch)');
  
  optionButtons.forEach(button => {
    const label = button.querySelector('.option-label');
    if (!label) return;
    
    const text = label.textContent.trim();
    
    // Format size labels (S, M, L, XL, etc.)
    if (/^(xs|s|m|l|xl|xxl|xxxl)$/i.test(text)) {
      label.textContent = text.toUpperCase();
    }
    
    // Format number sizes (numeric dimensions or values)
    if (/^\d+(\.\d+)?("|cm|mm|oz|kg)?$/.test(text)) {
      // It's a numeric size, leave as is but make sure to apply proper styling
      button.classList.add('numeric-option');
    }
  });
} 